import { DEVELOPMENT, FULL, IFilters, IVacancy, IVacancyLog } from "../utils";
import { withRetry } from "./axios";

export async function getVacancies(pages: number, visited: string, filters?: IFilters): Promise<{vacancies?: IVacancy[], total?: {value: number, relation: 'eq' | 'gte'}}> {
  if (process.env.REACT_APP_MODE === DEVELOPMENT) {
    const vacancies = []
    for (let i = 0; i < pages; i++) {
      vacancies.push(...fakeVacancies)
    }
    return {vacancies, total: {value: vacancies.length, relation: 'eq'}}
  }

  const res = await withRetry(async (instance) => instance.get('/vacancies', 
    {
      params: {
        text: filters?.keyWords.join(' '),
        employments: filters?.employments?.map(emp => emp.value).join(';'),
        city: filters?.city?.value,
        experience: filters?.experience?.value,
        sources: filters?.sources.join(';'),
        companies: filters?.filterByCompanies ? filters.companies.join(';') : undefined,
        visited,
        pages
      }
    }
  ))
  const {vacancies=[], total} = res.data

  return {vacancies, total}
}

export async function setvacancyVisited(vacancyId: string)  {
  const res = await withRetry(async (instance) => instance.post('/vacancies/visited', {id: vacancyId}))

  return res.status === 200
}

export async function setVacancyFavourite(vacancyId: string, isFavourite: boolean)  {
  const res = await withRetry(async (instance) => instance.post('/vacancies/favourite', {id: vacancyId, isFavourite}))

  return res.status === 200
}

export async function getVacanciesLogs(): Promise<IVacancyLog[]> {
  const res = await withRetry(async (instance) => instance.get('/vacancies/logs'))
  
  return res.data.logs
}

var fakeVacancies: IVacancy[] = [
  {
    id: "id",
    source: "HH",
    name: 'title',
    salaryFrom: 100,
    salaryTo: 500,
    currency: 'RUR',
    city: 'city',
    employer: 'company',
    experience: 'experience',
    employment: FULL,
    url: 'url1',
    visited: false,
    favourite: false,
    createdAt: Date.now().toLocaleString()
  },
]